import React from 'react';
import { Box } from '@mui/material';
import { guaranteesClientPageStyles } from '~/modules/guarantees/form/client/styles.ts';
import GuaranteesManagerApplicationSidePanel from './GuaranteesManagerApplicationSidePanel.tsx';
import type { IGuaranteesManagerApplicationSidePanelLayoutProps } from './types.ts';
import { useGuaranteesManagerApplicationSidePanel } from './useGuaranteesManagerApplicationSidePanel.ts';

const GuaranteesManagerApplicationSidePanelLayout: React.FC<
  IGuaranteesManagerApplicationSidePanelLayoutProps
> = ({ applicationId, children, onError }) => {
  const sidePanelProps = useGuaranteesManagerApplicationSidePanel({
    applicationId,
    onError,
  });
  const sidePanel = (
    <GuaranteesManagerApplicationSidePanel
      filesBlockProps={sidePanelProps.filesBlockProps}
      statusFlowProps={sidePanelProps.statusFlowProps}
    />
  );

  return (
    <Box sx={guaranteesClientPageStyles.applicationWithStatusSidebar}>
      <Box sx={guaranteesClientPageStyles.applicationStatusSidebarMobile}>{sidePanel}</Box>
      <Box>{children}</Box>
      <Box sx={guaranteesClientPageStyles.applicationStatusSidebarDesktop}>{sidePanel}</Box>
    </Box>
  );
};

export default GuaranteesManagerApplicationSidePanelLayout;
